export default __webpack_public_path__ + "700cd0ab5068cfe518d80c97aa57a344.jpg";